import { EWalletId } from '@ankr.com/provider';

import { getProviderManager } from 'modules/core';

import { api } from '../api';
import { cacheTags } from '../cacheTags';

interface UpdateAccountArgs {
  address: string;
  walletId: EWalletId;
}

export const {
  useUpdateAccountAddressMutation,
  endpoints: { updateAccountAddress },
} = api.injectEndpoints({
  endpoints: build => ({
    updateAccountAddress: build.mutation<string, UpdateAccountArgs>({
      queryFn: async ({ walletId, address }) => {
        const instance = await getProviderManager();
        const provider = await instance.getETHWriteProvider(walletId);
        provider.currentAccount = address;

        return { data: address };
      },
      invalidatesTags: [
        cacheTags.account,
        cacheTags.chainData,
        cacheTags.balance,
      ],
    }),
  }),
});
